import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function Footer() {
  return (
    <footer className="bg-dark text-white mt-4">
      <Container>
        <Row className="py-4">
          <Col className="text-center">
            <p>&copy; {new Date().getFullYear()} Handy Man. All rights reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
